// extracted by mini-css-extract-plugin
export var active = "Utils-module--active--bV0Cy";
export var anchor = "Utils-module--anchor--u1dng";
export var bxTextTruncateEnd = "Utils-module--bx--text-truncate--end--hfEen";
export var bxTextTruncateFront = "Utils-module--bx--text-truncate--front--qX4tN";
export var feedbackButton = "Utils-module--feedbackButton--6ij8a";
export var feedbackModal = "Utils-module--feedbackModal--Y+b2i";
export var popupActive = "Utils-module--popupActive--DhMin";
export var topButton = "Utils-module--topButton---tj5r";
export var topButtonShow = "Utils-module--topButtonShow--HwPFB";